module.exports = __webpack_public_path__ + "img/edit.ad219f33.svg";